export default {
  store_namespace: 'product',
  auth_feature: 'product',
  new_route_name: "AdminProductNew",
  edit_route_name: "AdminProductEdit",
  detail_route_name: "AdminProductDetail",
  csv_export_filename_prefix: 'product',
  hide_action_new_button: true,
  hide_action_pdf_button: true,
  hide_action_edit_button: false,
  hide_action_delete_button: true,
  submit_formatter: item => ({
    ...item,
    family: {
      id: item.family_id,
    },
    // available: {
    //   id: item.product_shops.available,
    // },
  }),
  export_csv: true,
  export_pdf: true,
  title_field: 'code',
  sort_by: 'code',
  sort_desc: false,
  fields: [
    {
      name: 'code',
      label: "Code",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      sortable: true,
      disabled: true
    },
    {
      name: 'label',
      label: "Label",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      filterIn: true,
      inDetail: true,
      sortable: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'description',
      label: "Description",
      type: 'textarea',
      inForm: true,
      required: true,
      inList: false,
      filterIn: false,
      inDetail: true,
      sortable: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'family_id',
      label: "Famille de produit",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'family',
      label: "Famille de produit",
      type: 'select',
      sortable: true,
      inForm: false,
      inList: true,
      filterIn: true,
      extended_filter: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? value.name : null
    },
    {
     name: 'photos',
     label: "Photos",
     type: 'group_repeater',
     inForm: true,
     canDrag: true,
     fields: [{
       name: 'name',
       label: "Fichier",
       type: 'file',
       inForm: true,
     }]
   },
   {
    name: 'specifications',
    label: "Spécifications",
    type: 'group_repeater',
    inForm: true,
    fields: [{
      name: 'name',
      label: "Nom",
      type: 'text',
      inForm: true,
    },
    {
      name: 'value',
      label: "Valeur",
      type: 'text',
      inForm: true,
    }
    ]
  },
   {
    name: 'documents',
    label: "Documents",
    type: 'group_repeater',
    inForm: true,
    fields: [{
      name: 'name',
      label: "Fichier",
      type: 'file',
      inForm: true,
    }]
   },
  ]
}



// WEBPACK FOOTER //
// ./src/components/Product/config.js